import { useState, useEffect } from 'react';

export default function useLocalStorage(key, defaultValue) {
  //  Synchronous hydrate from localStorage
  const [value, setValue] = useState(() => {
    try {
      const json = localStorage.getItem(key);
      return json != null ? JSON.parse(json) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  //  Persist whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {}
  }, [key, value]);

  return [value, setValue];
}
